<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="6">
            <h2>Portal de propostas</h2>
          </b-col>
          <b-col
            cols="auto"
            class="ml-auto"
          >
            <b-dropdown
              v-if="((nomeArquivo && nomeArquivo !== '') || (nomeVideo && nomeVideo !== ''))"
              size="sm"
              variant="success"
              style="padding-top: 0.2rem;padding-bottom: 0.2rem;"
              class="dropdown-arquivo"
              toggle-class="visualizacao-color"
            >
              <template #button-content>
                Visualize nossa apresentação (Clique aqui)
              </template>
              <b-dropdown-item-btn
                v-if="(nomeVideo && nomeVideo !== '')"
                @click="openVideo"
              >
                Apresentação em vídeo</b-dropdown-item-btn>
              <b-dropdown-item-btn
                v-if="(nomeArquivo && nomeArquivo !== '')"
                @click="openArquivo"
              >
                Apresentação em arquivo</b-dropdown-item-btn>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <fieldset class="font-weight-bold text-muted small">
              Aqui você pode visualizar suas propostas e realizar as ações disponíveis
            </fieldset>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="3"
          >
            <proposta-multiselect
              v-model="filtroInicial.numeroProposta"
              :multiple="true"
              :filtro-adicional="filtroPropostaPessoa"
              :externo="true"
            />
          </b-col>
          <b-col
            cols="6"
          >
            <status-select
              v-model="filtroInicial.status"
              :multiple="true"
              :itens-status="itensStatus"
            />
          </b-col>
          <b-col
            cols="auto"
            class="ml-auto"
          >
            <legend class="col-form-label pt-2" />
            <div style="padding-top:6.218px">
              <div style="display: contents;">
                <b-btn
                  variant="none"
                  class="btn-success btn-sm mr-50 ml-50"
                  @click.prevent.stop="limpar()"
                >Limpar</b-btn>
                <b-btn
                  variant="none"
                  class="btn-success btn-sm"
                  @click="aplicar()"
                >Aplicar</b-btn>
              </div>
            </div>
          </b-col>
        </b-row>
        <hr
          class="mx-0 mt-0 my-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
        <b-row>
          <b-col cols="12">
            <vue-good-table
              id="proposta"
              ref="propostas"
              :columns="colunas"
              :rows="propostas"
              :total-rows="totalLinhas"
              :row-style-class="'clickable'"
              :column-filter="false"
              :pagination-options="{
                enabled: true,
                perPage: 10
              }"
              @on-page-change="onAlterarPagina"
              @on-cell-click="abrir"
            >
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span
                  v-if="props.column.field === 'status'"
                  v-b-tooltip
                  :title="getStatusHint(props.row)"
                >
                  <font-awesome-icon
                    :class="{'text-blue': props.row.status === 'aguardando' || props.row.status === 'checklist'
                               || props.row.justificativa === 'Contrato enviado por email para assinatura!' || props.row.status === 'checklistrespondido',
                             'text-warning': (props.row.status === 'aprovada' && props.row.tipoProposta !== 'semchecklist') && props.row.justificativa === 'Dados enviados! O contrato será enviado por email',
                             'text-yellow': props.row.status === 'aprovada' && props.row.justificativa === 'Preencha os dados do pré-contrato, clique aqui!',
                             'text-success': props.row.status === 'aprovada' && props.row.tipoProposta === 'semchecklist' || props.row.status === 'finalizada',
                             'text-danger': props.row.status === 'naoaprovada' || props.row.status === 'rejeitado',
                             'text-secondary': props.row.status === 'expirada'}"
                    :icon="getIconeStatus(props.row)"
                    style="font-size:16px !important;width:20px"
                  />
                </span>
                <span
                  v-else-if="props.column.field === 'servicos'"
                >
                  <span
                    v-if="(props.row.servico && props.row.servico[0]) || (props.row.propostaPacotes && props.row.propostaPacotes[0])"
                    style="white-space:nowrap"
                  >
                    <div class="divservico-full">
                      <div>
                        <span
                          class="tag-portal"
                        >
                          {{ tagPraColocar(props.row) }}
                        </span>
                        <span
                          v-if="habilitarBotao(props.row)"
                          :id="`servico${props.row.id}`"
                          class="botao-num-restante"
                        >
                          {{ nomeBotao(props.row) }}
                        </span>
                      </div>
                      <b-popover
                        :target="`servico${props.row.id}`"
                        triggers="hover"
                        placement="bottom"
                      >
                        <div
                          slot="title"
                          class="titulo-pop"
                        >
                          <b-row style="font-size: small;">
                            <span>Nº {{ props.row.numeroProposta }}</span>
                          </b-row>
                          <b-row style="font-size: small;">
                            <span>Serviços dessa proposta</span>
                          </b-row>
                        </div>
                        <div>
                          <div v-if="props.row.propostaPacotes != null && props.row.propostaPacotes.length > 0">
                            <div
                              v-for="item in props.row.propostaPacotes[0].servicos"
                              :key="item.id"
                            >
                              <b-row>
                                <b-col cols="12">
                                  <span>{{ item.nome }}</span>
                                  <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                          <div v-if="props.row.servico">
                            <div
                              v-for="item in props.row.servico.filter(f => !f.servicoAdicional)"
                              :key="item.id"
                            >
                              <b-row>
                                <b-col cols="12">
                                  <span>{{ item.servico.nome }}</span>
                                  <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                                </b-col>
                              </b-row>
                            </div>
                            <div
                              v-for="item in props.row.servico.filter(f => f.servicoAdicional)"
                              :key="item.id"
                            >
                              <b-row>
                                <b-col cols="12">
                                  <span>{{ item.servico.nome }}</span>
                                  <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                                </b-col>
                              </b-row>
                            </div>
                          </div>
                        </div>
                      </b-popover>
                    </div>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'acoes'">
                  <div class="d-inline-flex">
                    <b-btn
                      v-b-tooltip.hover
                      title="Proposta"
                      variant="none"
                      :class="['mr-50', 'btn-actions', 'cor-icones', 'acao-proposta',
                               {'cor-desabilitado': desabilitarProposta(props.row)}]"
                      :disabled="desabilitarProposta(props.row)"
                      @click="abrirTemplateProposta(props.row)"
                    >
                      <font-awesome-icon
                        :icon="faEye"
                        style="font-size:14px !important;width:20px"
                      />
                      Proposta
                    </b-btn>
                    <b-btn
                      v-b-tooltip.hover
                      title="Contrato"
                      variant="none"
                      :class="['mr-50', 'btn-actions', 'cor-icones', 'acao-proposta',
                               {'cor-desabilitado': desabilitarContrato(props.row)}]"
                      :disabled="desabilitarContrato(props.row)"
                      @click="abrirTemplateContrato(props.row)"
                    >
                      <font-awesome-icon
                        :icon="faEye"
                        style="font-size:14px !important;width:20px"
                      />
                      Contrato
                    </b-btn>
                    <b-btn
                      variant="none"
                      :class="['mr-50', 'btn-actions', 'cor-icones', 'acao-proposta', {'cor-desabilitado': desabilitarChecklist(props.row)}]"
                      :disabled="props.row.tipoProposta !== 'constituicao' && props.row.tipoProposta !== 'transferencia'"
                      @click="abrirChecklist(props.row)"
                    >
                      <font-awesome-icon
                        :icon="faEdit"
                        style="font-size:14px !important;width:20px"
                      />
                      Checklist
                    </b-btn>
                  </div>
                </span>
                <span
                  v-else-if="props.column.field === 'valor' && props.row.valor > 0"
                >
                  {{ props.row.valor | converteValor }}
                </span>
                <span v-else-if="props.column.field === 'valor' && props.row.valor === 0" />
                <span
                  v-else-if="props.column.field === 'statusAtual'"
                >
                  <div
                    v-if="props.row.status == 'aguardando' && !props.row.escolhaPacote"
                    style="padding-top:6.218px;"
                  >
                    <div style="display: contents;">
                      <b-btn
                        variant="none"
                        class="btn-success btn-sm mr-50 ml-50"
                        style="font-size:10px;"
                        @click="propostaAprovada(props.row, false, '')"
                      >
                        <font-awesome-icon
                          :icon="faThumbsUp"
                          style="font-size:10px !important;width:20px"
                        />Aprovar</b-btn>
                      <b-btn
                        variant="none"
                        class="btn-danger btn-sm"
                        style="font-size:10px;"
                        @click="alterarStatus(props.row, 'Não aprovar')"
                      >
                        <font-awesome-icon
                          :icon="faThumbsDown"
                          style="font-size:10px !important;width:20px"
                        />Recusar</b-btn>
                    </div>
                  </div>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </span>
                <span
                  v-else-if="props.column.field === 'justificativa'"
                >
                  <span class="aprovacao-coluna">
                    {{ getTextoJustificativa(props.row.justificativa) }}
                    <span
                      v-if="props.row.justificativa && props.row.justificativa.includes('clique aqui!')"
                      class="link"
                    > clique aqui!</span>
                  </span>
                  <span
                    v-if="props.row.propostaEmpresas && props.row.propostaEmpresas.length > 0"
                    style="font-size: 12px;"
                  >Contratante(s): </span>
                  <b-badge
                    v-for="(emp, $index) in props.row.propostaEmpresas"
                    :key="$index"
                    v-b-tooltip.hover
                    :title="`${emp}`"
                    variant="none"
                    class="tabela-tag-contratante"
                  >
                    {{ emp.length > 18 ? `${emp.substring(0, 28)}...` : emp }}
                  </b-badge>
                </span>
                <span v-else-if="props.column.field === 'log'">
                  <div class="d-inline-flex">
                    <b-btn
                      v-b-tooltip.hover
                      title="Trâmite"
                      variant="none"
                      class="mr-50 btn-actions cor-icones"
                    >
                      <font-awesome-icon
                        :icon="faComment"
                        style="font-size:14px !important;width:20px"
                        @click="abrirTramiteCliente(props.row)"
                      />
                    </b-btn>
                    <b-btn
                      v-b-tooltip.hover
                      title="Histórico"
                      variant="none"
                      class="btn-actions cor-icones"
                      @click="abrirHistorico(props.row)"
                    >
                      <font-awesome-icon
                        :icon="faHistory"
                        style="font-size:14px !important;width:20px"
                      />
                    </b-btn>
                  </div>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <!-- no records -->
              <div slot="emptystate">
                <p style="text-align:center; margin:0">
                  Não existem dados para o filtro informado!
                </p>
              </div>
              <!-- pagination -->
              <template
                slot="pagination-bottom"
                slot-scope="props"
              >
                <paginacao-base
                  :valor="props"
                  :quantidade="10"
                />
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <bem-vindo v-if="mostarBoaVindas" />

    <justificativa-proposta-modal
      v-if="mostrarJustificativa"
      :proposta-recusada="naoAprovado"
      @cancelar="cancelarJustificativa()"
      @hidden="aprovar(propostaSelecionada, naoAprovado, $event)"
    />

    <!-- Tramite pessoa e gerente -->
    <historico-proposta-modal
      v-if="mostrarTramite"
      :proposta-id="propostaSelecionada.id"
      :label="'Trâmites com o gerente'"
      :tipo-historico="'tramite'"
      @hidden="fecharTramite()"
    />

    <!-- Historico proposta -->
    <historico-proposta-modal
      v-if="mostrarHistorico"
      :proposta-id="propostaSelecionada.propostaIdVinculada"
      @hidden="fecharHistorico()"
    />

    <visualizar-arquivo
      v-if="mostrarVisualizacaoArquivo || mostrarVisualizacaoVideo"
      :url="url"
      @hidden="fecharVisualizarArquivo()"
    />

    <checklist-pacote
      ref="checklistPacote"
      :proposta="propostaSelecionada"
      @hidden="fecharCheckPacote"
      @adicionar-check="adicionarCheck($event)"
      @envio-checklist="envioChecklist($event)"
      @visualizar-pdf="abrirTemplatePropostaAprovada($event)"
      @escolha-pacote="pacoteEscolhido($event)"
      @status-proposta="aprovar($event.proposta, $event.naoAprovar, $event.justificativa)"
      @abrir-pre-geracao="buscaEmpresas($event)"
    />

    <pre-geracao-contrato
      ref="preGeracaoContrato"
      :proposta-atual="propostaSelecionada"
      @hidden="fecharPreGeracao"
      @fechado="fecharPreGeracao"
      @enviado="alterarStatusGrid"
    />

    <dados-contratante
      ref="dadosContrante"
      @aprovado="salvarContranteEAprovacao($event)"
    />
    <documentos-proposta-modal
      v-show="mostrarDocumentosModal"
      ref="documentosModal"
      :proposta-id="propostaIdDocumentosModal"
    />
  </b-card>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

#proposta table.vgt-table {
  font-size: 14px !important;
}
.titulo-pop{
  min-width: 50px;
  text-align :center;
  background-color: #00cc66;
  color: white;
}
.divservico-full{
  display: flex;
  min-width: 200px;
  max-width: 200px;
  //justify-content: space-between;
}
.tag-portal{
  margin-bottom: -5px;
  margin-top: -2px;
  border: 0.80px solid var(--primary) !important;
  background-color: transparent;
  color: var(--primary) !important;
  font-size: 12px;
  padding: 4px !important;
  display: inline-flex;
  font-weight: bold;
  border-radius: 6px;
  max-width: 180px;
  margin-right: 0.5rem;
}
.botao-num-restante{
  font-size: 1.1rem;
background-color: transparent;
color: #00cc66;
font-weight: bold;
float: right;
}
.aprovacao-coluna {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.tramiteDiv{
  display: block;
text-align: left;
width: 25em;
margin-top: 1em;}
.Tramitetag{
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  display: inline-block;
    font-size: 10px;
    //font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    vertical-align: baseline;
    padding: 0.3rem 0.5rem;
    text-align: center;
    border-radius: 0.358rem;
    border: 1px solid var(--primary);
    color: var(--primary)
}
.btn-actions {
  padding: 0 !important;
}

.text-yellow {
  color: #DFC927 !important;
}

.acao-proposta {
  display: inline-flex;
  align-items: center;
  font-size:14px!important;
}

.cor-desabilitado {
  color: #82868b !important;
}

.visualizacao-color {
  border-color: #283046 !important;
  background-color: #283046 !important;

  &:active { background-color: #283046 !important; }

  &:focus { background-color: #283046 !important; }
}

.header-left {
  text-align: left !important;
}

.text-blue {
  color: #549fc7 !important;
}

.cor-icones, .cor-icones:hover {
  color: var(--primary);
}

.dropdown-arquivo .dropdown-item:active {
  background-color: rgb(173, 240, 173);
}

.dropdown-arquivo .dropdown-item:hover {
  color: var(--primary);
}

.dropdown-arquivo .btn{
  color: var(--primary);
}

.dropdown-arquivo .dropdown-item {
  color: var(--primary);
}

.link {
  text-decoration: underline #0c26df;
  color: #0c26df;
  font-weight: bold;
}

.link {
  text-decoration: underline #0c26df;
  color: #0c26df;
  font-weight: bold;
}

// .custom-header {
//   min-width: 570px;
// }

.tabela-tag-contratante {
  border: 1px solid var(--primary);
  color: var(--primary);
  margin-right: 0.5rem;
  font-size: 10px;
  font-weight: 500;
  padding: 2px;
}

.contratantes-swal {
  display: block;
  text-align: left;
  width: 25em;
  margin-top: 1em;
}

.tag-contratantes-swal {
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  vertical-align: baseline;
  padding: 0.3rem 0.5rem;
  text-align: center;
  border-radius: 0.358rem;
  border: 1px solid var(--primary);
  color: var(--primary)
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHourglass, faTimesCircle, faBan, faThumbsUp, faThumbsDown, faHistory, faEdit, faEye, faUserCheck, faUserClock, faFileSignature, faInfoCircle, faClock,
} from '@fortawesome/free-solid-svg-icons'
import {
  faComment,
} from '@fortawesome/free-regular-svg-icons'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/services/api'
import apiPessoa from '@/app-modulo/comercial/pessoa/shared/services/api'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import docuSign from '@/shared/mixins/docu-sign/docu-sign'
import { getUserData } from '@/auth/utils'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'PortalProposta',
  components: {
    VueGoodTable,
    FontAwesomeIcon,
    PropostaMultiselect: () => import('@/shared/components/proposta-multiselect/PropostaMultiselect.vue'),
    StatusSelect: () => import('@/shared/components/status-select/StatusSelect.vue'),
    HistoricoPropostaModal: () => import('@/app-modulo/comercial/portal-proposta/shared/components/historico-proposta/HistoricoProposta.vue'),
    JustificativaPropostaModal: () => import('@/app-modulo/comercial/portal-proposta/shared/components/justificativa-proposta/JustificaProposta.vue'),
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
    PaginacaoBase: () => import('@/shared/components/paginacao-base/PaginacaoBase.vue'),
    ChecklistPacote: () => import('@/app-modulo/comercial/portal-proposta/shared/components/checklist-pacote/ChecklistPacote.vue'),
    BemVindo: () => import('@/app-modulo/comercial/portal-proposta/shared/components/bem-vindo-portal/BemVindoPortal.vue'),
    PreGeracaoContrato: () => import('@/app-modulo/comercial/portal-proposta/shared/components/pre-geracao-contrato/PreGeracaoContrato.vue'),
    DadosContratante: () => import('./shared/components/dados-contratante/DadosContratanteExterno.vue'),
    DocumentosPropostaModal: () => import('./shared/components/documentos-proposta/DocumentosPropostaModal.vue'),
  },
  data() {
    return {
      faHourglass,
      faTimesCircle,
      faBan,
      faThumbsUp,
      faThumbsDown,
      faComment,
      faHistory,
      faEdit,
      faEye,
      faUserCheck,
      faUserClock,
      faFileSignature,
      faInfoCircle,
      faClock,
      nomeVideo: null,
      nomeArquivo: null,
      itensStatus: [{ tipo: 'aguardando', nome: 'Aguardando' },
        { tipo: 'aprovada', nome: 'Aprovada' },
        { tipo: 'naoaprovada', nome: 'Não aprovada' },
        { tipo: 'rejeitado', nome: 'Rejeitada' },
        { tipo: 'expirada', nome: 'Expirada' },
        { tipo: 'checklist', nome: 'Checklist' }],
      filtroInicial: {
        numeroProposta: [],
        status: [
          { tipo: 'aguardando', nome: 'Aguardando' },
          { tipo: 'naoaprovada', nome: 'Não aprovada' },
          { tipo: 'aprovada', nome: 'Aprovada' },
          { tipo: 'checklist', nome: 'Checklist' }],
      },
      colunas: [{
        label: 'Status', field: 'status', width: '80px', tdClass: 'text-center', sortable: false,
      },
      {
        label: 'Ações', field: 'acoes', width: '90px', tdClass: 'text-right', sortable: false,
      },
      {
        label: 'Serviços', field: 'servicos', width: '220px', tdClass: 'text-left', sortable: false,
      },
      {
        label: 'Alterar status', field: 'statusAtual', width: '220px', sortable: false,
      },
      {
        label: 'Valor', field: 'valor', width: '170px', sortable: false,
      },
      {
        label: 'Número', field: 'numeroProposta', width: '160px', sortable: false,
      },
      {
        label: 'Trâmite',
        field: 'justificativa',
        width: '400px',
        // tdClass: 'custom-header',
        sortable: false,
      },
      {
        label: 'Log', field: 'log', width: '90px', tdClass: 'text-right', sortable: false,
      },
      ],
      statusSelecionado: {},
      mostrarHistorico: false,
      mostrarTramite: false,
      propostaSelecionada: null,
      mostarTemplateProposta: false,
      mostarContratoProposta: false,
      mostrarJustificativa: false,
      propostas: [],
      naoAprovado: false,
      mostrarVisualizacaoArquivo: false,
      url: null,
      arquivoDeletar: null,
      mostrarVisualizacaoVideo: false,
      mostarBoaVindas: false,
      limit: 0,
      servidorParams: {
        filtros: {
          data: {},
          modulo: '',
          ordemBy: [
            {
              coluna: '',
              tipo: '',
            },
          ],
        },
        page: 1,
        perPage: 10,
      },
      totalLinhas: 0,
      mostrarDocumentosModal: false,
      propostaIdDocumentosModal: null,
    }
  },
  created() {
    document.querySelector(':root').style.setProperty('--primary', '#00cc66')
    document.querySelector(':root').style.setProperty('--primary-rgb', '0, 204, 102')
    apiPessoa.mostrarMensagem(getUserData().id)
      .then(payload => {
        this.mostarBoaVindas = payload.data
      })

    apiParametrizacao.getParametrizacaoResumidaPortal()
      .then(payload => {
        this.nomeVideo = payload.data.nomeVideo
        this.nomeArquivo = payload.data.nomeArq
      })
      .catch(err => {
        this.$router.push({ name: 'portalproposta' })
        throw err
      })
    this.aplicar()
  },
  methods: {
    tagPraColocar(value) {
      if (value.propostaPacotes.length !== 0 && value.propostaPacotes[0].servicos) {
        if (value.propostaPacotes[0].servicos[0].nome.length > 20) {
          return `${value.propostaPacotes[0].servicos[0].nome.substring(0, 20)}...`
        }
        return value.propostaPacotes[0].servicos[0].nome
      }
      if (value.servico[0].servico.nome.length > 20) {
        return `${value.servico[0].servico.nome.substring(0, 20)}...`
      }
      return value.servico[0].servico.nome
    },
    nomeBotao(value) {
      this.numservicoprop = 0
      if (value.propostaPacotes !== null && value.propostaPacotes.length !== 0) {
        this.numservicoprop = value.propostaPacotes[0].servicos.length
      }

      const numservicos = value.servico.length
      if (value.propostaPacotes.length !== 0 && value.propostaPacotes[0].servicos && (numservicos + this.numservicoprop - 1) > 0) {
        return `+${numservicos + this.numservicoprop - 1}`
      }
      const total = value.servico.length - 1
      return total > 0 ? `+${value.servico.length - 1}` : ''
    },
    habilitarBotao(value) {
      if (value.tipoProposta === 'semchecklist' && value.propostaPacotes.length !== 0 && value.propostaPacotes[0].servicos.length > 0) {
        return true
      }
      if (value.propostaPacotes.length !== 0) {
        return value.servico && value.servico.length > 0
      }
      return value.servico && value.servico.length > 0
    },
    getTextoJustificativa(value) {
      if (value && value.includes('clique aqui!')) {
        return value.replace('clique aqui!', '')
      }
      return value
    },
    desabilitarContrato(value) {
      if (!value.geraContrato) {
        return true
      }

      if ((value.geraContrato || value.tipoProposta === 'semchecklist') && value.status !== 'aprovada' && value.status !== 'aguardandoassinatura' && value.status !== 'finalizada') {
        return true
      }

      return (!value.geradoProposta && !value.dataChecklistRetorno) || (value.geradoProposta && value.escolhaPacote)
    },
    desabilitarChecklist(value) {
      if (value.tipoProposta !== 'constituicao' && value.tipoProposta !== 'transferencia') {
        return true
      }
      return false
    },
    desabilitarProposta(proposta) {
      return ((proposta.tipoProposta === 'constituicao' || proposta.tipoProposta === 'transferencia') && (!proposta.geradoProposta))
      || proposta.status === 'naoaprovada'
    },
    aplicar() {
      this.propostas = []
      api.getPropostas(this.servidorParams.page, this.servidorParams.perPage, this.filtroInicial)
        .then(payload => {
          this.propostas = payload.data.queryable
          this.totalLinhas = payload.data.rowCount
          const propostasId = this.propostas.filter(proposta => proposta.status === 'aguardando' || proposta.status === 'checklist')
            .map(proposta => proposta.propostaIdVinculada)
          api.AddVisualizacaoPortal(propostasId)
        })
        .catch(err => {
          this.notificarErro('Não foi possível carregar as propostas.', err)
          throw err
        })
    },
    limpar() {
      this.filtroInicial = {
        numeroProposta: [],
        status: [],
      }
    },
    getStatusHint(value) {
      if (value.status === 'aguardando') {
        return 'Aguardando'
      }

      if (value.status === 'aprovada' && value.tipoProposta !== 'semchecklist') {
        if (value.justificativa === 'Preencha os dados do pré-contrato, clique aqui!') {
          return 'Aprovada - Aguardando envio de dados'
        }
        if (value.justificativa === 'Dados enviados! O contrato será enviado por email') {
          return 'Aprovada - Em análise'
        }
      }

      if (value.status === 'naoaprovada') {
        return 'Não aprovada'
      }

      if (value.status === 'rejeitado') {
        return 'Rejeitada'
      }

      if (value.status === 'expirada') {
        return 'Expirada'
      }

      if (value.status === 'checklist') {
        return 'Checklist aguardando resposta'
      }

      if (value.status === 'checklistrespondido') {
        return 'Checklist respondido'
      }

      if (value.status === 'aguardandoassinatura') {
        return 'Aprovada - Aguardando assinatura'
      }

      if (value.status === 'finalizada') {
        return 'Aprovada - Finalizada'
      }

      return ''
    },
    getIconeStatus(value) {
      if (value.status === 'aguardando') {
        return this.faHourglass
      }

      if (value.status === 'aprovada' && value.justificativa === 'Preencha os dados do pré-contrato, clique aqui!') {
        return faInfoCircle
      }

      if (value.status === 'aprovada' && value.justificativa === 'Dados enviados! O contrato será enviado por email') {
        return faClock
      }

      if (value.status === 'aprovada' || value.status === 'finalizada') {
        return this.faThumbsUp
      }

      if (value.status === 'aguardandoassinatura') {
        return this.faFileSignature
      }

      if (value.status === 'naoaprovada') {
        return this.faThumbsDown
      }

      if (value.status === 'rejeitado') {
        return this.faBan
      }

      if (value.status === 'expirada') {
        return this.faTimesCircle
      }

      if (value.status === 'checklist') {
        return this.faUserClock
      }

      if (value.status === 'checklistrespondido') {
        return this.faUserCheck
      }

      return ''
    },
    filtroPropostaPessoa(propostas) {
      const userData = getUserData()
      if (userData.id > 0) {
        let propostasFilt = []
        propostasFilt = propostas.filter(fil => fil.pessoaId === userData.id && fil.numeroProposta && fil.numeroProposta !== '')
        return propostasFilt
      }
      return null
    },
    cancelarJustificativa() {
      this.propostaSelecionada = null
      this.mostrarJustificativa = false
      this.statusSelecionado = {}
    },
    alterarStatus(proposta, naoAprovar) {
      this.mostrarJustificativa = false
      this.propostaSelecionada = null

      this.propostaSelecionada = proposta
      this.mostrarJustificativa = true
      if (naoAprovar === 'Não aprovar') {
        this.mostrarJustificativa = true
        this.naoAprovado = true
      } else if (naoAprovar === 'Aprovar') {
        this.mostrarJustificativa = true
        this.naoAprovado = false
      }
    },
    salvarContranteEAprovacao(dadosContrante) {
      const proposta = this.propostas.find(fin => fin.id === this.propostaSelecionada.id)
      this.propostaSelecionada = null
      this.aprovar(proposta, false, '', dadosContrante)
      this.abrirDocumentosModal(proposta)
    },
    propostaAprovada(proposta, naoAprovar, justObse) {
      if (proposta.semContratante) {
        this.propostaSelecionada = proposta
        this.$refs.dadosContrante.show()
      } else {
        this.propostaSelecionada = proposta
        this.aprovar(proposta, naoAprovar, justObse)
        this.abrirDocumentosModal(proposta)
      }
    },
    aprovar(proposta, naoAprovar, justObse, dadosContrante = {}) {
      this.$isLoading(true)
      api.aprovarProposta(proposta.id, naoAprovar, justObse, dadosContrante)
        .then(payload => {
          // eslint-disable-next-line no-nested-ternary
          this.$set(proposta, 'status', payload.data.status === 'naoaprovada' ? 'naoaprovada' : proposta.geraContrato ? 'aprovada' : 'finalizada')
          this.$set(proposta, 'justificativa', proposta.geraContrato && proposta.tipoProposta !== 'semchecklist' && payload.data.status !== 'naoaprovada' ? 'Preencha os dados do pré-contrato, clique aqui!' : payload.data.justificativa)
          this.$set(proposta, 'statusAtual', payload.data.status === 'naoaprovada' ? 'Não aprovada' : 'Aprovada')
          this.cancelarJustificativa()
          this.notificarSucesso(`Proposta ${payload.data.status === 'naoaprovada' ? 'não aprovada' : 'aprovada'}.`)

          if (proposta.geraContrato && !naoAprovar && proposta.tipoProposta !== 'semchecklist') {
            this.buscaEmpresas(proposta)
          } else if (!proposta.geraContrato && !naoAprovar && proposta.tipoProposta !== 'semchecklist') {
            apiEmpresa.cadastroEmpresaPropostaPortal(proposta.propostaIdVinculada)
          }
        })
        .catch(err => {
          this.cancelarJustificativa()
          this.notificarErro('Não foi possível alterar o status da proposta.', err)
          throw err
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    buscaEmpresas(proposta) {
      this.propostaSelecionada = proposta
      this.$refs.preGeracaoContrato.$refs.preGeracao.show()
      api.addVisualizacaoPreGeracao(proposta.propostaId)
    },
    abrirHistorico(proposta) {
      this.mostrarHistorico = true
      this.propostaSelecionada = proposta
    },
    fecharHistorico() {
      this.mostrarHistorico = false
      this.propostaSelecionada = null
    },
    fecharTramite() {
      this.mostrarTramite = false
      this.propostaSelecionada = null
    },
    abrirTramiteCliente(proposta) {
      this.mostrarTramite = true
      this.propostaSelecionada = proposta
    },
    openArquivo() {
      apiParametrizacao.getUrlArquivoPortal()
        .then(payload => {
          this.url = payload.data
          this.mostrarVisualizacaoArquivo = true
        })
    },
    fecharVisualizarArquivo() {
      if (this.arquivoDeletar && this.arquivoDeletar !== '') {
        docuSign.deletarArquivo(this.arquivoDeletar, true)
          .then(() => {
            this.arquivoDeletar = null
          })
      }
      this.mostrarVisualizacaoArquivo = false
      this.mostrarVisualizacaoVideo = false
    },
    openVideo() {
      apiParametrizacao.getUrlVideoPortal()
        .then(payload => {
          this.url = payload.data
          this.mostrarVisualizacaoVideo = true
        })
    },
    fecharVisualizarVideo() {
      this.mostrarVisualizacaoVideo = false
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    notificarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'SuccessCircleIcon',
          variant: 'success',
        },
      })
    },
    abrirTemplateProposta(proposta) {
      if (proposta.escolhaPacote) {
        this.abrirChecklist(proposta)
      } else if (proposta.status !== 'naoaprovada') {
        this.abrirTemplatePropostaAprovada(proposta)
      }
    },
    abrirTemplatePropostaAprovada(proposta) {
      api.getPDFPropostaContrato(proposta.propostaIdVinculada, true)
      const routeData = this.$router.resolve({ name: 'relatorioproposta', params: { id: proposta.propostaIdVinculada, externa: true } })
      window.open(routeData.href, '_blank')
    },
    abrirTemplateContrato(proposta) {
      if (proposta.status === 'aguardandoassinatura') {
        this.$confirmarHtml('', '<div>O contrato foi enviado para assinatura no email dos sócios e estará disponível para download quando todos concluírem a assinatura!</div>', 'success', '')
      } else if (proposta.status === 'finalizada') {
        this.abrirDocumentoContrado(proposta)
      } else {
        this.propostaSelecionada = proposta
        this.$refs.preGeracaoContrato.$refs.preGeracao.show()
        api.addVisualizacaoPreGeracao(proposta.propostaId)
      }
    },
    abrirDocumentoContrado(proposta) {
      docuSign.getArquivoContrato(proposta.propostaId, true)
        .then(payload => {
          // eslint-disable-next-line prefer-destructuring
          const url = payload.data.url
          this.arquivoDeletar = payload.data.fileName
          window.open(url, '_blank')
          setTimeout(() => {
            docuSign.deletarArquivo(this.arquivoDeletar)
          }, 3000)
        })
    },
    abrir(params) {
      if (params.column.field !== 'acoes' && (params.row.tipoProposta === 'constituicao' || params.row.tipoProposta === 'transferencia')
         && (params.row.justificativa === 'Preencha os dados do pré-contrato, clique aqui!') && params.row.status === 'aprovada' && params.row.geraContrato) {
        this.abrirTemplateContrato(params.row)
      } else if (params.column.field === 'justificativa' && ((params.row.justificativa && params.row.justificativa !== '') || (params.row.propostaEmpresas && params.row.propostaEmpresas.length > 0)) && !params.row.escolhaPacote
       && ((params.row.justificativa && !params.row.justificativa.includes('Responda o checklist, clique aqui!')) || params.row.geradoProposta || params.row.dataValidade || params.row.status === 'checklistrespondido')) {
        this.apresentaJustificativaCompleta(params)
      } else if (params.column.field !== 'acoes' && params.column.field !== 'log'
      && (params.row.tipoProposta === 'constituicao' || params.row.tipoProposta === 'transferencia')
         && ((!params.row.geradoProposta && !params.row.dataChecklistRetorno) || (params.row.geradoProposta && params.row.escolhaPacote))) {
        this.abrirChecklist(params.row)
      }
    },
    apresentaJustificativaCompleta(params) {
      let cnpjs = ''
      if (params.row.propostaEmpresas && params.row.propostaEmpresas.length > 0) {
        cnpjs += '<div class="contratantes-swal">Contratante(s): '
        params.row.propostaEmpresas.forEach(element => {
          cnpjs += `<span class="tag-contratantes-swal">${element.length > 18 ? `${element.substring(0, 28)}...` : element}</span>`
        })
      }
      this.$swal({
        html: `${!params.row.justificativa ? '' : params.row.justificativa}<br>${cnpjs}</div>`,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
    fecharCheckPacote() {
      this.propostaSelecionada = null
    },
    alterarStatusGrid() {
      this.atualizaGrid(this.propostaSelecionada.id)
      this.propostaSelecionada = null
    },
    fecharPreGeracao() {
      this.propostaSelecionada = null
    },
    adicionarCheck(value) {
      const prop = this.propostas.find(fin => fin.id === value.propostaId)
      this.$set(prop, 'itemChecklistPropostas', value.itens.itemChecklistPropostaDetails)
      this.$set(prop, 'tributacao', value.itens.tributacao)
      this.$set(prop, 'atividade', value.itens.atividade)
      this.$set(prop, 'filial', value.itens.filial)
      this.$set(prop, 'tipoEmpresa', value.itens.tipoEmpresa)
    },
    envioChecklist(value) {
      const prop = this.propostas.find(fin => fin.id === value.propostaId)
      this.$set(prop, 'justificativa', value.justificativa)
      this.$set(prop, 'dataChecklistRetorno', value.itens.dataEnvioChecklist)
      this.$set(prop, 'status', 'checklistrespondido')
      this.$set(prop, 'itemChecklistPropostas', value.itens.itemChecklistPropostaDetails)
      this.$set(prop, 'tributacao', value.itens.tributacao)
      this.$set(prop, 'atividade', value.itens.atividade)
      this.$set(prop, 'filial', value.itens.filial)
      this.$set(prop, 'tipoEmpresa', value.itens.tipoEmpresa)
    },
    abrirChecklist(value) {
      this.propostaSelecionada = value
      if (this.propostaSelecionada.escolhaPacote && this.propostaSelecionada.status === 'aguardando') {
        api.addVisualizacaoEscolhaPacote(this.propostaSelecionada.propostaId)
      } else {
        api.addVisualizacaoChecklist(this.propostaSelecionada.propostaId)
      }
      this.$refs.checklistPacote.$refs.modalChecklistPacote.show()
    },
    pacoteEscolhido(value) {
      const index = this.propostas.findIndex(fin => fin.id === value.id)
      this.propostas.splice(index, 1)
      this.propostas.splice(index, 0, value)
    },
    atualizaGrid(id) {
      const prop = this.propostas.find(fin => fin.id === id)
      this.$set(prop, 'status', 'aprovada')
      this.$set(prop, 'justificativa', 'Dados enviados! O contrato será enviado por email')
      this.$set(prop, 'statusAtual', 'Aprovada')
    },
    updateParams(newProps) {
      this.servidorParams = { ...this.servidorParams, ...newProps }
    },
    onAlterarPagina(params) {
      this.updateParams({ page: params.currentPage })
      this.aplicar()
    },
    onAlterarOrdenacao(params) {
      this.servidorParams.filtros.ordemBy = [
        { tipo: params[0].type, coluna: params[0].field },
      ]
      this.aplicar()
    },
    abrirDocumentosModal(proposta) {
      api.getPropostaDocumentos(proposta.propostaId)
        .then(response => {
          const propostaDocumentos = response.data
          if (propostaDocumentos && propostaDocumentos.length > 0) {
            this.setPropostaIdDocumentosModal(proposta.propostaId)
            this.mostrarDocumentosModal = true
            this.$nextTick(() => {
              if (this.$refs.documentosModal && this.$refs.documentosModal.show) {
                this.$refs.documentosModal.show()
              }
            })
          }
        })
    },
    setPropostaIdDocumentosModal(id) {
      this.propostaIdDocumentosModal = id
    },
  },
}
</script>
